<template lang="pug">
  div.itm(v-if="dis === true",@click="click",@mousedown="mousedown",@touchstart="mousedown",draggable="false")
    div.dragitem(:style="sty()", :data-src="'./static/front/' + item.code + '.svg'", :data-w="item.w.split('、')[0]")
      img(:src="frontImg()")
      div.cross
    div.thumb
      img(:src="'./static/thumb/' + item.code + '.jpg'")
      div.size D = {{ item.d * 10 }}
    div.info
      figure
        img(:src="'./static/thumb/' + item.code + '.jpg'")
      div.spec
        div.name {{ item.name }}
        div.price {{ item.price }}円
        dl.width(v-if="check(item.w)")
          dt 横幅
          dd {{ item.w }}mm
        dl.height(v-if="check(item.h)")
          dt 高さ
          dd {{ item.h * 10 }}mm
        dl.depth(v-if="check(item.d)")
          dt 奥行
          dd  {{ item.d * 10 }}mm
</template>

<script>
import store from '../../stores/index';
export default {
  name: 'SideMenu',
  data () {
    return {
      dis: true,
      fg: false,
      itemfg: false,
      itemCheck: false,
      outRange: false,
      flr: false,
      chk: -1,
      posY: 0,
      $tar: {},
      $drag: {},
      $info: {}
    };
  },
  props: {
    dat: Object
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    }
  },
  methods: {
    update () {
      if (this.sets[this.number] === undefined) return false;
      this.set = this.sets[this.number];
      this.slits = this.set.slits;
      this.height = this.c2p(this.set.size[1]);
      if (this.slits[0].slit !== undefined) this.hole = Number(this.slits[0].slit.hole);
      if (this.set.space[2] < this.item.d) {
        this.dis = false;
      } else if (this.item.d === '') {
        this.dis = true;
      } else {
        this.dis = true;
      }
    },
    click (e) {
      // 商品情報表示
      this.$tar = e.currentTarget;
      // if (!this.$tar.querySelector('.info')) {
      //   this.$tar.appendChild(this.$info);
      // }
      this.$info = this.$tar.querySelector('.info');
      this.$info.style.top = this.mp(e).clientY + 'px';

      if (this.$info.style.display !== 'flex') {
        this.$info.style.display = 'flex';
        // document.querySelector('body').appendChild(this.$info);
        window.addEventListener('mouseout', this.mouseout, false);
        window.addEventListener('touchcancel', this.mouseout, false);
      } else {
        this.$info.style.display = '';
      }
    },
    mouseout (e) {
      if (this.$tar) {
        this.$info.style.display = '';
        // this.$tar.appendChild(this.$info);
        window.removeEventListener('mouseout', this.mouseout);
        window.removeEventListener('touchcancel', this.mouseout);
      }
    },
    mousedown (e) {
      this.$drag = e.currentTarget.querySelector('.dragitem');
      document.querySelector('body').appendChild(this.$drag);
      e.currentTarget.classList.add('dragging');
      const result = {
        message: '',
        position: ''
      };
      store.commit('setMessageWarning', result);
      window.addEventListener('mousemove', this.mousemove, false);
      window.addEventListener('mouseup', this.mouseup, false);
      window.addEventListener('touchmove', this.mousemove, false);
      window.addEventListener('touchend', this.mouseup, false);
    },
    mousemove (e) {
      let me = this;
      let parent;
      if (me.$drag) {
        let ah = (me.height / me.hole);
        me.chk = me.mouseSlit(e); // ドラック要素がどのスリット内か調べる
        me.flr = false;
        if (me.chk !== -1) {
          parent = document.querySelector('.items-area .slit:nth-child(' + (me.chk + 1) + ')');
          let rect = parent.querySelector('.flr').getBoundingClientRect();
          if (rect.x < this.mp(e).clientX && rect.x + rect.width > this.mp(e).clientX) {
            if (rect.y < this.mp(e).clientY && rect.y + rect.height > this.mp(e).clientY) {
              me.flr = true;
            }
          }
        }
        // ドラック要素をスリットに移動
        if (me.prev !== me.chk && me.chk !== -1) {
          parent.appendChild(me.$drag);
        } else if (me.prev !== me.chk) {
          document.querySelector('body').appendChild(me.$drag);
        }
        me.$drag.style.display = 'block';
        if (me.chk === -1) {
          me.$drag.style.position = 'fixed';
          me.$drag.style.left = (this.mp(e).clientX - me.$drag.offsetWidth / 2) + 'px';
          me.$drag.style.top = (this.mp(e).clientY - me.$drag.offsetHeight / 2) + 'px';
          me.$drag.style.bottom = '';
          me.prev = me.chk;
        } else {
          me.space = me.slits[me.chk + 1].pos - me.slits[me.chk].pos;
          let ismm = me.slits[me.chk + 1].span + me.slits[me.chk].span;
          // スリットの横幅にあう商品を調べる
          me.itemfg = false;
          for (let prop in me.dat.item) {
            let itm = me.dat.item[prop];
            const isHasKentaKun = me.slits[me.chk].item.some(item => item.code.includes('KS'));
            if (!isHasKentaKun) {
              if (me.space === Number(itm.w)) {
                me.item = me.acopy(itm);
                me.$drag.style.width = me.c2p(me.space) + 'px';
                me.$drag.querySelector('img').src = './static/front/' + me.item.code + '.svg';
                me.itemfg = true;
              }
            } else {
              const checkW60 = me.slits[me.chk + 1].item.some(item => item.code.includes('KS6060C'));
              if (ismm === Number(itm.w) && me.slits[me.chk + 1].span === 30 && !checkW60) {
                me.item = me.acopy(itm);
                me.$drag.style.width = me.c2p(ismm) + 'px';
                me.$drag.querySelector('img').src = './static/front/' + me.item.code + '.svg';
                me.itemfg = true;
              }
            }
          }
          let rect = parent.getBoundingClientRect();
          me.posY = Math.round((this.mp(e).clientY - rect.y) / ah);
          let tp = me.checkTop(me.item.code);
          if (me.posY * ah < ah * tp) {
            me.posY = tp;
          } else if (me.hole < me.posY + me.item.hole) {
            me.posY = me.hole - me.item.hole;
          }
          let pos = me.posY * ah;
          // 他商品と重なりチェック
          me.fg = false;
          for (let prop in me.slits[me.chk].item) {
            let itm = me.slits[me.chk].item[prop];
            if (me.posY + me.item.hole > itm.y && me.posY < itm.y + itm.hole) {
              me.fg = true;
            }
          }
          if (me.space < Number(me.item.w) && me.item.code.includes('KS')) {
            me.slits[me.chk].item.find(item => {
              if (item.code.includes('KS')) {
                me.itemfg = false;
              } else {
                me.itemfg = true;
              }
            });
          }
          if (me.flr || (me.item.under && !me.item.upper)) {
            let elements = document.querySelectorAll('.items-area .slit:nth-child(' + (me.chk + 1) + ') .items .item');
            if (elements) {
              let btm = 0;
              elements.forEach(function (userItem, i) {
                if (btm < userItem.getBoundingClientRect().bottom) {
                  btm = userItem.getBoundingClientRect().bottom;
                }
              });
              if (btm >= me.$drag.getBoundingClientRect().top) {
                me.fg = true;
              }
              if (document.querySelector('.items-area .slit:nth-child(' + (me.chk + 1) + ') .flr .item')) {
                me.fg = true;
              }
            }
          } else {
            if (document.querySelector('.items-area .slit:nth-child(' + (me.chk + 1) + ') .flr .item')) {
              let floor = document.querySelector('.items-area .slit:nth-child(' + (me.chk + 1) + ') .flr .item');
              if (floor.getBoundingClientRect && floor !== null) {
                if (me.$drag.getBoundingClientRect().bottom >= floor.getBoundingClientRect().top) {
                  me.fg = true;
                }
              }
            }
          }
          if (!me.itemfg && me.chk !== -1) {
            me.fg = true;
          }
          // バツアイコン表示
          if (me.fg) {
            me.$drag.querySelector('.cross').style.display = 'flex';
          } else {
            me.$drag.querySelector('.cross').style.display = 'none';
          }
          // ドラッグ要素のスタイル設定
          if (me.item.under && !me.item.upper) {
            me.$drag.style.top = 'auto';
            me.$drag.style.bottom = '0px';
          } else if (me.item.under && me.flr) {
            me.$drag.style.top = 'auto';
            me.$drag.style.bottom = '0px';
          } else if (me.item.upper) {
            me.$drag.style.top = pos + 'px';
            me.$drag.style.bottom = '';
          } else {
          }
          me.$drag.style.left = '0px';
          me.$drag.style.position = 'absolute';
        }
      }
    },
    mouseup (e) {
      this.$drag.style.left = '';
      this.$drag.style.top = '';
      this.$drag.style.display = '';
      this.$el.appendChild(this.$drag);
      if (this.chk !== -1 && !this.fg) {
        this.item.y = this.posY;
        this.item.dat = this.dat;
        let ary = [];
        for (let prop in this.dat.item) {
          let w = this.dat.item[prop].w;
          ary[w] = this.acopy(this.dat.item[prop]);
        }
        this.item.ary = ary;
        this.item.cat = this.dat.cat;
        this.item.display = true;
        // if (this.flr || (this.item.under && !this.item.upper)) {
        if (this.item.under) {
          this.item.flr = true;
          this.item.upper = false;
          this.item.y = -1;
          this.slits[this.chk].floor.splice(0, 1, this.item);
        } else {
          this.item.flr = false;
          this.item.under = false;
          this.slits[this.chk].item.push(this.item);
        }
        this.sets.splice(this.number, 1, this.sets[this.number]);
        if (this.item.code.includes('KS')) {
          let mm;
          let rate = this.item.w > 60 ? 2 / 3 : 1 / 2;
          if (this.slits[this.chk].pos > 1) {
            mm = (this.slits[this.chk + 1].pos - this.slits[this.chk].pos) * rate + this.slits[this.chk].pos;
          } else {
            mm = (this.slits[this.chk].pos + this.slits[this.chk + 1].pos) * rate;
          }
          let obj = {
            display: true,
            pos: this.item.w > 60 ? mm - 5 : mm,
            item: [],
            floor: [],
            slit: {},
            outRange: this.outRange
          };
          this.slits.splice(this.chk + 1, 0, obj);
          this.updateSlit(this.set);
        }
      }
      // ドラッグ商品リセット
      this.$drag.style.width = this.c2p(Number(this.$drag.getAttribute('data-w'))) / 10 + 'px';
      this.$drag.querySelector('img').src = this.$drag.getAttribute('data-src');
      this.chk = -1;
      window.removeEventListener('mousemove', this.mousemove);
      window.removeEventListener('mouseup', this.mouseup);
      window.removeEventListener('touchmove', this.mousemove);
      window.removeEventListener('touchend', this.mouseup);
    },
    sty () {
      return {
        width: this.c2p(this.item.w.split('、')[0]) / 10 + 'px'
      };
    },
    frontImg () {
      let img = './static/front/' + this.item.code + '.svg';
      return img;
    },
    check (n) {
      if (n !== '' && n !== undefined && n !== 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  created () {
    this.item = this.dat.thumb;
    this.update();
  },
  mounted () {
    if (this.dat !== undefined) {
      this.$el.item = this.dat;
    }
  }
};
</script>

<style lang="stylus" scoped>
  .aside
    position absolute
    left 0
    top 51px
    bottom 0
    width 160px
    background-color #ffffff
    border-right 1px solid #dddddd
  .tit
    padding 10px
    font-size 12px
    font-weight bold
    color #2E7C80
    border-bottom 1px solid #dddddd
  .items
    position absolute
    left 0
    right 0
    top 40px
    bottom 0
    overflow-y auto
    padding 15px
    .itm
      cursor pointer
      user-select none
      position relative
      z-index 1
      margin-bottom 5px
      .thumb
        position relative
        line-height 1
        border 1px solid #dddddd
        img
          height 59.58px
          aspect-ratio 4 / 3
          object-fit fill
          width 100%
          pointer-events none
        .size
          position absolute
          left 2px
          bottom 2px
          font-size 10px
  .info
    color #ffffff
    background-color #00000088
    padding 8px
    border-radius 5px
    /*position absolute*/
    position fixed
    left 160px
    top 0
    display none
    z-index 100
    transform translate(0, -50%)
    figure
      width 120px
      overflow hidden
      img
        width 100%
        aspect-ratio 4 / 3
        object-fit fill
    .spec
      padding 0 0 0 10px
      .name
        font-weight bold
        font-size 14px
      div,dl
        font-weight bold
        font-size 13px
      .price
        text-align right
      dl
        display flex
        justify-content space-between
  .drag
    position absolute
    left 0
    top 0
    width 100%
    height 100%
    background-color #00000011
    &.dragging
      display none
  .dragitem
    position fixed
    left 0
    top 0
    /* width 10px
    height 10px
    background-color #000000*/
    z-index 1000
    pointer-events none
    user-select none
    display none
    line-height 1
    img
      width 100%
    .cross
      display none
      justify-content center
      align-items center
      width 20px
      height 20px
      background-color #cc0000
      color #ffffff
      line-height 1
      border-radius 50%
      position absolute
      left 50%
      top 0
      transform translate(-50%, 0)
      &:before
        content ""
        display block
        width 10px
        height 2px
        background-color #ffffff
        position absolute
        left 50%
        top 50%
        transform translate(-50%,-50%) rotate(45deg)
      &:after
        content ""
        display block
        width 10px
        height 2px
        background-color #ffffff
        position absolute
        left 50%
        top 50%
        transform translate(-50%,-50%) rotate(-45deg)
  &.dragging
    display block
</style>



// WEBPACK FOOTER //
// src/components/sidemenu/Item.vue